export const VERSION = import.meta.env.VITE_PLATFORM_VERSION
